import styled from 'styled-components'

const StyledShareNowSlide = styled.div`
  
`

export default StyledShareNowSlide
